module.controller('planSamplingHomeCtrl', [ '$scope', '$rootScope', '$state', 'planSamplingService', 'alertService', 'permissionStatesService', 'securityService',
		function($scope, $rootScope, $state, planSamplingService, alertService, stateService, securityService) {

			$scope.idPlanSampling = $state.params.id;
			$scope.planSamplingHome = {};
			$scope.loading = false;
			$scope.idClient = {};
			$scope.steps = [];
			$scope.stepCurrent = 0;

			$scope.isEdition = function() {
				return $scope.planSamplingHome.state === PLAN_SAMPLING_STATE.EDITION.enumName;
			};
			$scope.isProgress = function() {
				return $scope.planSamplingHome.state === PLAN_SAMPLING_STATE.PROGRESS.enumName;
			};
			$scope.isFinished = function() {
				return $scope.planSamplingHome.state === PLAN_SAMPLING_STATE.FINISHED.enumName;
			};
			$scope.isAnnul = function() {
				return $scope.planSamplingHome.state === PLAN_SAMPLING_STATE.ANNUL.enumName;
			};

			$scope.loadHomeInfoSuccess = function(response){
				$scope.loading = false;
				var responseData = response.getData();
				$scope.planSamplingHome = responseData;

				var state = getConstantById(PLAN_SAMPLING_STATE, $scope.planSamplingHome.state);

				$scope.planSamplingHome.className = state.className;
				$scope.stepCurrent = getIndexState(state.name);
			};
			
			$scope.loadHomeInfoError = function(){
				$scope.loading = false;
				$state.go('home.planSamplingList');
			};
			
			/**
			 * Carga infromacion del plan de muestreo
			 */
			$scope.loadHomeInfo = function(idPlanSampling) {
				$scope.loading = true;

				if (securityService.hasRole(ROLE_TYPE.CLIENT.code)) {
					planSamplingService.getPlanSamplingHomeForClientUser(idPlanSampling).then(function(response) {
						$scope.loadHomeInfoSuccess(response);

					}, function(response) {
						$scope.loadHomeInfoError();
					});
				}
				else{
					planSamplingService.getPlanSamplingHome(idPlanSampling).then(function(response) {
						$scope.loadHomeInfoSuccess(response);

					}, function(response) {
						$scope.loadHomeInfoError();
					});
				}
				
			};

			/**
			 * Inicia el plan de muestreo
			 */
			$scope.initPlan = function() {
				$scope.loading = true;
				alertService.showSwtQuestion('Iniciar plan de Muestreo', function() {
					planSamplingService.startPlanSampling($scope.idPlanSampling).then(function(response) {
						$scope.loading = false;
						$scope.loadHomeInfo($scope.idPlanSampling);
						alertService.showSuccess('Plan de muestreo iniciado satisfactoriamente');
					}, function(response) {
						$scope.loading = false;
					});
				});
				
				
			};

			/**
			 * Cancela el pln de muestreo
			 */
			$scope.cancelPlan = function() {
				$scope.loading = true;
				alertService.showSwtQuestion('Cancelar plan de Muestreo', function() {
					planSamplingService.cancelPlanSampling($scope.idPlanSampling).then(function(response) {
						$scope.loading = false;
						if ($scope.planSamplingHome.state === 'EDITION') {
							$state.go('home.planSamplingList');
							alertService.showSuccess('Plan de muestreo eliminado satisfactoriamente');
						} else {
							$scope.loadHomeInfo($scope.idPlanSampling);
							alertService.showSuccess('Plan de muestreo cancelado satisfactoriamente');
						}
					}, function(response) {
						$scope.loading = false;
					});
				});
			};

			$scope.canEdit = function() {
				return stateService.canEditPlanSampling($scope.planSamplingHome.state);
			}

			$scope.canInit = function() {
				return stateService.canInitPlanSampling($scope.planSamplingHome.state);
			}

			$scope.canCancel = function() {
				return stateService.canCancelPlanSampling($scope.planSamplingHome.state);
			}

			function getIndexState(state) {
				var s = getState(state);
				if (!s)
					return -1;
				return s.index;
			}

			function getState(state) {
				return $scope.steps.find(function(s) {
					return s.name === state;
				});
			}

			loadSteps();
			function loadSteps() {
				$scope.steps = [ {
					name : PLAN_SAMPLING_STATE.EDITION.name,
					index : 0
				}, {
					name : PLAN_SAMPLING_STATE.PROGRESS.name,
					index : 1
				}, {
					name : PLAN_SAMPLING_STATE.FINISHED.name,
					index : 2
				} ];
			}

			/**
			 * Carga la informacion a paenas inicia
			 */
			$scope.loadHomeInfo($scope.idPlanSampling);
			
		} ]);
